import BackendRepositoryRemote from '../api/BackendRepositoryRemote';
import { BackendRepository } from '../api/interfaces/BackendRepository';

export default class QuestionsService {
  private repository: BackendRepository;

  constructor() {
    this.repository = new BackendRepositoryRemote();
  }

  public async completeQuestionnaire(serviceAppointmentId: string): Promise<void> {
    return this.repository.completeQuestionnaire(serviceAppointmentId)
      .catch((error: Error) => console.error('finish questionnaire error', error));
  }
}
